<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" sm="6" lg="3" v-if="showOriginal">
        <AttachmentItem
          :allowDelete="false"
          :file="originalAttachment"
          :size="$t('Original')"
          :hasPreview="originalAttachment.canDisplay"
          @onPreview="preview"
        />
      </v-col>
      <v-col
        v-for="file in attachments"
        :key="file.fileId"
        cols="12"
        sm="6"
        lg="3"
      >
        <AttachmentItem
          :allowDelete="allowDelete"
          :file="file"
          :size="formatSize(file)"
          :hasPreview="file.canDisplay"
          @onPreview="preview"
          @onRemove="remove"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Utils from "@/ecm/common/Utils";
import AttachmentItem from "@/components/document/documentModal/attachment/AttachmentItem";

export default {
  components: {
    AttachmentItem,
  },
  props: {
    attachments: {
      type: Array,
    },
    originalAttachment: {
      type: Object,
    },
    allowDelete: {
      type: Boolean,
      default: true,
    },
    documentId: {
      type: Number,
    },
  },
  computed: {
    showOriginal() {
      return this.originalAttachment.fileId > 0;
    },
  },
  methods: {
    formatSize(file) {
      return Utils.file.bytesToSize(file.size);
    },    
    preview(file) {
      this.$emit("onPreview", file);
    },
    remove(file) {
      this.$emit("onRemove", file);
    }    
  },
};
</script>